import Common from '../../Common';

const TFA = class extends Common {
	async status(userId?: id) {
		if (userId) {
			return this.get(`/user/${userId}/tfa/status`);
		}

		return this.get(`/user/tfa/status`);
	}

	async read(userId: id) {
		if (userId) {
			return this.get(`/user/${userId}/tfa`)
		}

		return this.get(`/user/tfa`)
	}

	async create(secret: string) {
		return this.post(`/user/tfa`, {secret})
	}

	async validate(code: string, secret: string) {
		return this.post(`/user/tfa/validate`, {code, secret});
	}

	async force(userId: id, data: {force: 1 | 0}) {
		return this.post(`/user/${userId}/tfa/force`, data)
	}

	async delete(userId: id) {
		return this.post(`/user/${userId}/tfa/delete`)
	}
}

export default TFA
